import * as Types from '../../../../../graphql/src/lib/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Admin' } | { __typename?: 'Customer', id: string, userId?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, currencyIsoCode?: string | null, intercomHashId: string, countryCode: string, hasMaximize?: boolean | null } | { __typename?: 'Mechanic' } };

export type CustomerInfosFragment = { __typename?: 'Customer', id: string, userId?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, currencyIsoCode?: string | null, intercomHashId: string, countryCode: string, hasMaximize?: boolean | null };

export const CustomerInfosFragmentDoc = gql`
    fragment CustomerInfos on Customer {
  id
  userId
  firstName
  lastName
  email
  currencyIsoCode
  intercomHashId
  countryCode
  hasMaximize
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    ...CustomerInfos
  }
}
    ${CustomerInfosFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    override document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }